import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
    key: 0,
    src: "/themes/suchy/logo-suchy-webshop_1.png?v=2111221232",
    width: "300",
    alt: "Suchy Messtechnik"
};
const _hoisted_2 = {
    key: 1,
    src: "/themes/suchy/logo-suchy-webshop_2.png?v=2111221232",
    width: "170",
    alt: "Suchy Messtechnik",
    class: "mb-2 mt-2"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        (_ctx.logoMode === 'simple')
            ? (_openBlock(), _createElementBlock("img", _hoisted_1))
            : _createCommentVNode("", true),
        (_ctx.logoMode === 'default')
            ? (_openBlock(), _createElementBlock("img", _hoisted_2))
            : _createCommentVNode("", true)
    ], 64));
}
